import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { IApp } from './../stores';
import { pagesDictionary } from '../../data/content';
import { toPath } from '../../../common/helpers/toPath';
import { Login } from './user/login/Login';
import { EUserTypeName } from '../../../common/interfaces/user';

// Styles
require('./../styles/reset.css');
require('./../styles/index.css');
require('./../styles/table.css');

interface IMainProps extends IApp {
    match: any;
}

// Component
@inject('store')
@observer
export class Main extends React.Component<IApp, {}> {
    constructor(props) {
        super(props);
    }

    private renderPageByUserType = () => {
        const userTypeNameAsPath = toPath(this.props.store.user.userType);
        const component =
            typeof pagesDictionary[userTypeNameAsPath] !== 'undefined' ? pagesDictionary[userTypeNameAsPath].component : null;
        return component !== null ? React.createElement(component as any) : React.createElement('div');
    };

    public render() {
        return <div>{this.props.store.user.userType !== null ? this.renderPageByUserType() : <Login />}</div>;
    }
}

export default Main;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/index.tsx